<label class="has-float-label {{labelClass}}" [class.error]="isInvalid">
  <ng-content></ng-content>
  <span>{{label}}</span>
</label>
